import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FirmwareState } from '../reducers/firmware.reducer';

export const selectFirmwareState = createFeatureSelector<FirmwareState>('firmware');

export const selectFirmwareItems = createSelector(
  selectFirmwareState,
  state => state.firmwareItems,
);

export const selectIsLoading = createSelector(selectFirmwareState, state => state.isLoading);

export const selectFirmwareError = createSelector(selectFirmwareState, state => state.error);

export const selectIsUpdatingFirmware = createSelector(
  selectFirmwareState,
  state => state.isUpdatingFirmware,
);

export const selectFirmwareUpdateSuccess = createSelector(
  selectFirmwareState,
  state => state.firmwareUpdateSuccess,
);

export const selectIsBulkUpdating = createSelector(
  selectFirmwareState,
  state => state.isBulkUpdating,
);

export const selectBulkUpdateProgress = createSelector(
  selectFirmwareState,
  state => state.bulkUpdateProgress,
);

export const selectBulkUpdateResponse = createSelector(
  selectFirmwareState,
  state => state.bulkUpdateResponse,
);

export const selectBulkDlmsUpdateResponse = createSelector(
  selectFirmwareState,
  state => state.bulkDlmsUpdateResponse,
);
